module.exports = __webpack_public_path__ + "static/media/email-scanned-vs-alerts.c9e46f9d.png";